// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../../assets/images/banner/lady-two.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../../assets/images/alternative_images/computer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../../../assets/images/alternative_images/washer.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../../../assets/images/alternative_images/cooker.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../../../assets/images/alternative_images/dress.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../../../../assets/images/alternative_images/heel.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.banner-buy-on-pamo {
  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
  border-radius: 45px;
  opacity: 1;
}

.floating-btn {
  margin-left: -8%;
  bottom: 0;
  margin-bottom: 5%;
  transition: transform 0.5s ease-in-out;
  animation: bounce 1.5s infinite;
}

.btn-glass {
  background: rgba(255, 255, 255, 0.13);
  border-radius: 16px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(5.5px);
  -webkit-backdrop-filter: blur(5.5px);
}

.floating-btn:hover {
  animation: bounce 1.5s infinite;
}

@keyframes bounce {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-15px);
  }
}
.banner-col-1-text {
  font-size: 50px;
}

.background-image-col {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  height: 400px;
  position: absolute;
  margin-left: 10%;
  margin-top: 1%;
  position: absolute;
}

.card-on-hover {
  width: 200px;
  height: 210px;
  border-radius: 30px;
  margin-left: 20%;
  margin-top: -5% !important;
}

.orange-spot {
  height: 10px;
  background: salmon;
}

.spot {
  position: absolute;
  margin-top: -10% !important;
  background: salmon;
}

.alternating-images-on-hover-buy {
  width: 220px !important;
  height: 200px !important;
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: absolute;
  left: -20% !important;
  margin-top: -50% !important;
  animation: SwapImage 30s infinite;
}

@keyframes SwapImage {
  100% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  20% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  }
  40% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
  }
  60% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  }
  80% {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
}
@media only screen and (max-width: 1830px) {
  .background-image-col {
    width: 700px !important;
  }
}
@media only screen and (max-width: 1616px) {
  .background-image-col {
    margin-left: -10% !important;
  }
}
@media only screen and (max-width: 1410px) {
  .background-image-col {
    margin-left: -20% !important;
  }
}
@media only screen and (max-width: 1399px) {
  .background-image-col {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain !important;
    width: 600px !important;
    height: 100% !important;
    position: absolute !important;
    margin-left: -4% !important;
    margin-top: 13%;
    position: absolute;
  }
  .card-on-hover {
    margin-top: -10% !important;
    margin-left: 10% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 45px !important;
  }
}
@media only screen and (max-width: 1280px) {
  .background-image-col {
    margin-left: -20% !important;
  }
  card-on-hover {
    margin-left: 25% !important;
    margin-top: 15% !important;
  }
}
@media only screen and (max-width: 1199px) {
  .background-image-col {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-size: contain !important;
    width: 600px !important;
    height: 100% !important;
    position: absolute !important;
    margin-left: -6% !important;
    margin-top: 10%;
    position: absolute;
  }
  .card-on-hover {
    margin-top: -10% !important;
    margin-left: 0% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 35px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
}
@media only screen and (max-width: 1099px) {
  .background-image-col {
    background-image: none !important;
  }
  card-on-hover {
    margin-left: 5% !important;
    margin-top: 15% !important;
  }
}
@media only screen and (max-width: 991px) {
  .background-image-col {
    background-image: none !important;
    width: 100% !important;
  }
  .card-on-hover {
    margin-top: 5% !important;
    margin-left: -70% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    font-size: 30px !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
  }
  .banner-buy-on-pamo {
    padding: 15px 10px !important;
  }
  .floating-btn {
    margin-left: -2% !important;
    bottom: 0;
    margin-bottom: 5%;
  }
}
@media only screen and (max-width: 950px) {
  .card-on-hover {
    margin-top: 5% !important;
    margin-left: -120% !important;
  }
}
@media only screen and (max-width: 899px) {
  .card-on-hover {
    margin-top: 20% !important;
    margin-left: -140% !important;
  }
}
@media only screen and (max-width: 865px) {
  .card-on-hover {
    margin-top: 30% !important;
    margin-left: -170% !important;
  }
}
@media only screen and (max-width: 850px) {
  .card-on-hover {
    margin-top: 35% !important;
    margin-left: -220% !important;
  }
}
@media only screen and (max-width: 830px) {
  .card-on-hover {
    margin-top: 35% !important;
    margin-left: -350% !important;
  }
}
@media only screen and (max-width: 810px) {
  .card-on-hover {
    margin-top: 45% !important;
    margin-left: -400% !important;
  }
}
@media only screen and (max-width: 799px) {
  .card-on-hover {
    margin-top: 5% !important;
    margin-left: -550% !important;
  }
}
@media only screen and (max-width: 781px) {
  .card-on-hover {
    margin-top: 5% !important;
    margin-left: -750% !important;
  }
}
@media only screen and (max-width: 770px) {
  .card-on-hover {
    margin-top: 5% !important;
    margin-left: -750% !important;
  }
}
@media only screen and (max-width: 767px) {
  .background-image-col {
    background-image: none !important;
  }
  .card-on-hover {
    margin-top: -4% !important;
    margin-left: 0% !important;
  }
  .download-btn {
    font-size: 12px !important;
  }
  .banner-col-1-text {
    width: 100% !important;
  }
  .get-app-btn {
    margin: 10px 0px !important;
    padding: 15px 25px !important;
  }
  .banner-buy-on-pamo {
    padding: 15px 10px !important;
  }
  .floating-btn {
    margin-left: -2% !important;
    bottom: 0;
    margin-bottom: 5%;
  }
  .banner-text-sub {
    font-weight: lighter !important;
    font-size: 15px !important;
  }
  .text-link {
    font-size: 12px !important;
    font-weight: lighter !important;
  }
}
@media only screen and (max-width: 620px) {
  .promo-section {
    padding: 0% 0% !important;
  }
  .shimmer-container {
    padding: 0% 0% !important;
  }
  #banner-section {
    width: 100% !important;
    padding: 0px 0% !important;
  }
  .banner-buy-on-pamo {
    background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;
    border-radius: 0px !important;
    width: 100% !important;
    margin: 0% !important;
    height: 100%;
  }
  .banner-col-1-text .banner-text {
    font-size: 40px !important;
  }
}
@media only screen and (max-width: 500px) {
  .banner-col-1-text .banner-text {
    font-size: 30px !important;
  }
}
@media only screen and (max-width: 430px) {
  .banner-col-1-text .banner-text {
    font-size: 30px !important;
  }
}
@media only screen and (max-width: 420px) {
  .banner-col-1-text .banner-text {
    font-size: 28px !important;
  }
}
@media only screen and (max-width: 404px) {
  .banner-col-1-text .banner-text {
    font-size: 28px !important;
  }
}
@media only screen and (max-width: 404px) {
  .banner-col-1-text .banner-text {
    font-size: 28px !important;
    line-height: 25px;
  }
}
@media only screen and (max-width: 385px) {
  .banner-buy-on-pamo {
    padding: 0px 0px !important;
  }
}
@media only screen and (max-width: 350px) {
  .banner-col-1-text .banner-text {
    font-size: 22px !important;
    line-height: 15px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/presentation/main/buy-on-pamo/component/banner/banner.scss"],"names":[],"mappings":"AAAA;EACE,mGAAA;EACA,mBAAA;EACA,UAAA;AACF;;AAGA;EACI,gBAAA;EACA,SAAA;EACA,iBAAA;EACA,sCAAA;EACA,+BAAA;AAAJ;;AAGA;EACE,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,4BAAA;EACA,oCAAA;AAAF;;AAIA;EACE,+BAAA;AADF;;AAKA;EACE;IACE,wBAAA;EAFF;EAIA;IACE,4BAAA;EAFF;AACF;AAKA;EACE,eAAA;AAHF;;AAOA;EACE,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AAJF;;AAOA;EACE,YAAA;EACF,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,0BAAA;AAJA;;AAOA;EAEE,YAAA;EACA,kBAAA;AALF;;AAQA;EACE,kBAAA;EACA,2BAAA;EACA,kBAAA;AALF;;AAQA;EAEE,uBAAA;EACA,wBAAA;EACA,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,qBAAA;EACA,2BAAA;EACA,iCAAA;AANF;;AASA;EACE;IACE,yDAAA;EANF;EAQA;IACE,yDAAA;EANF;EAQA;IACE,yDAAA;EANF;EAQA;IACE,yDAAA;EANF;EAQA;IACE,yDAAA;EANF;AACF;AAUA;EAEE;IACE,uBAAA;EATF;AACF;AAYA;EAEE;IACE,4BAAA;EAXF;AACF;AAcA;EAEE;IACE,4BAAA;EAbF;AACF;AAkBA;EACE;IACE,yDAAA;IACA,4BAAA;IACA,mCAAA;IACA,uBAAA;IACA,uBAAA;IACA,6BAAA;IACA,2BAAA;IACA,eAAA;IAEA,kBAAA;EAjBF;EAmBD;IACD,2BAAA;IACA,2BAAA;EAjBE;EAqBD;IACD,0BAAA;EAnBE;EAsBD;IACC,0BAAA;EApBA;AACF;AAwBA;EACE;IACE,4BAAA;EAtBF;EAyBA;IACA,2BAAA;IACA,0BAAA;EAvBA;AACF;AA0BA;EACE;IACE,yDAAA;IACA,4BAAA;IACA,mCAAA;IACA,uBAAA;IACA,uBAAA;IACA,6BAAA;IACA,2BAAA;IACA,eAAA;IAEA,kBAAA;EAzBF;EA2BD;IACD,2BAAA;IACA,0BAAA;EAzBE;EA6BD;IACD,0BAAA;EA3BE;EA8BD;IACC,0BAAA;EA5BA;EAgCF;IACE,2BAAA;EA9BA;AACF;AAkCA;EACE;IACE,iCAAA;EAhCF;EAmCA;IACA,0BAAA;IACA,0BAAA;EAjCA;AACF;AAqCA;EACE;IACE,iCAAA;IACA,sBAAA;EAnCF;EAsCD;IACD,yBAAA;IACA,4BAAA;EApCE;EAwCD;IACD,0BAAA;EAtCE;EAyCD;IACC,0BAAA;EAvCA;EA2CF;IACE,2BAAA;EAzCA;EA4CF;IACE,6BAAA;EA1CA;EA8CF;IACE,2BAAA;IACA,SAAA;IACA,iBAAA;EA5CA;AACF;AAiDA;EACE;IACE,yBAAA;IACA,6BAAA;EA/CF;AACF;AAmDA;EACE;IACE,0BAAA;IACA,6BAAA;EAjDF;AACF;AAqDA;EACE;IACE,0BAAA;IACA,6BAAA;EAnDF;AACF;AAuDA;EACE;IACE,0BAAA;IACA,6BAAA;EArDF;AACF;AAyDA;EACE;IACE,0BAAA;IACA,6BAAA;EAvDF;AACF;AA2DA;EACE;IACE,0BAAA;IACA,6BAAA;EAzDF;AACF;AA6DA;EACE;IACE,yBAAA;IACA,6BAAA;EA3DF;AACF;AA8DA;EACE;IACE,yBAAA;IACA,6BAAA;EA5DF;AACF;AA+DA;EACE;IACE,yBAAA;IACA,6BAAA;EA7DF;AACF;AAkEA;EACE;IACE,iCAAA;EAhEF;EAmED;IACD,0BAAA;IACA,0BAAA;EAjEE;EAqED;IACD,0BAAA;EAnEE;EAsED;IAEC,sBAAA;EArEA;EA0EF;IACE,2BAAA;IACA,6BAAA;EAxEA;EA2EF;IACE,6BAAA;EAzEA;EA4EF;IACE,2BAAA;IACA,SAAA;IACA,iBAAA;EA1EA;EA6EF;IACE,+BAAA;IACA,0BAAA;EA3EA;EA8EF;IACE,0BAAA;IACA,+BAAA;EA5EA;AACF;AA+EA;EACE;IACE,yBAAA;EA7EF;EAgFA;IACE,yBAAA;EA9EF;EAiFA;IACE,sBAAA;IACA,0BAAA;EA/EF;EAkFE;IACE,mGAAA;IACD,6BAAA;IACD,sBAAA;IACA,qBAAA;IACE,YAAA;EAhFJ;EAqFI;IACE,0BAAA;EAnFN;AACF;AAyFA;EAEI;IACE,0BAAA;EAxFJ;AACF;AA6FA;EAEM;IACE,0BAAA;EA5FN;AACF;AAgGA;EAEI;IACE,0BAAA;EA/FJ;AACF;AAqGA;EAEI;IACE,0BAAA;EApGJ;AACF;AAwGA;EAEI;IACE,0BAAA;IACA,iBAAA;EAvGJ;AACF;AA2GA;EACE;IACE,2BAAA;EAzGF;AACF;AA4GA;EAEI;IACE,0BAAA;IACA,4BAAA;EA3GJ;AACF","sourcesContent":[".banner-buy-on-pamo{\n  background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;\n  border-radius: 45px;\n  opacity: 1;\n}\n\n\n.floating-btn{\n    margin-left:-8%;\n    bottom:0;\n    margin-bottom:5%;\n    transition: transform 0.5s ease-in-out;\n    animation: bounce 1.5s infinite;\n}\n\n.btn-glass{\n  background: rgba(255, 255, 255, 0.13);\n  border-radius: 16px;\n  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n  backdrop-filter: blur(5.5px);\n  -webkit-backdrop-filter: blur(5.5px);\n \n}\n\n.floating-btn:hover{\n  animation: bounce 1.5s infinite;\n}\n\n\n@keyframes bounce {\n  0%, 100% {\n    transform: translateY(0);\n  }\n  50% {\n    transform: translateY(-15px);\n  }\n}\n\n.banner-col-1-text {\n  font-size:50px;\n  \n}\n\n.background-image-col{\n  background-image: url(\"../../../../../assets/images/banner/lady-two.png\");\n  background-repeat: no-repeat;\n  background-size: cover;\n  width:100%;\n  height:400px;\n  position:absolute;\n  margin-left:10%;\n  margin-top:1%;\n  position:absolute;\n}\n\n.card-on-hover{\n  width: 200px;\nheight: 210px;\nborder-radius: 30px;\nmargin-left: 20%;\nmargin-top: -5% !important;\n}\n\n.orange-spot {\n  // width: 10px;\n  height: 10px;\n  background: salmon;\n}\n\n.spot{\n  position:absolute;\n  margin-top:-10% !important;\n  background: salmon;\n}\n\n.alternating-images-on-hover-buy {\n  // background-image: url(\"../../../../../assets/images/banner/blue-bag.png\");\n  width: 220px !important;\n  height: 200px !important;\n  background-position: center;\n  background-size: contain;\n  background-repeat: no-repeat;\n  position: absolute;\n  left: -20% !important;\n  margin-top:-50% !important;\n  animation: SwapImage 30s infinite;\n}\n\n@keyframes SwapImage {\n  100% {\n    background-image: url(\"../../../../../assets/images/alternative_images/computer.png\");\n  }\n  20% {\n    background-image: url(\"../../../../../assets/images/alternative_images/washer.png\");\n  }\n  40% {\n    background-image: url(\"../../../../../assets/images/alternative_images/cooker.png\");\n  }\n  60% {\n    background-image: url(\"../../../../../assets/images/alternative_images/dress.png\");\n  }\n  80% {\n    background-image: url(\"../../../../../assets/images/alternative_images/heel.png\");\n  }\n}\n\n\n@media only screen and (max-width: 1830px) {\n\n  .background-image-col{\n    width:700px !important;\n  }\n}\n\n@media only screen and (max-width: 1616px) {\n\n  .background-image-col{\n    margin-left:-10% !important;\n  }\n}\n\n@media only screen and (max-width: 1410px) {\n\n  .background-image-col{\n    margin-left:-20% !important;\n  }\n}\n\n\n\n@media only screen and (max-width: 1399px) {\n  .background-image-col{\n    background-image: url(\"../../../../../assets/images/banner/lady-two.png\");\n    background-repeat: no-repeat;\n    background-size: contain !important;\n    width:600px !important;\n    height:100% !important;\n    position:absolute !important;\n    margin-left:-4% !important;\n    margin-top:13%;\n  \n    position:absolute;\n  }\n .card-on-hover{\nmargin-top:-10% !important;\nmargin-left: 10% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  font-size:45px !important;\n  \n}\n}\n\n@media only screen and (max-width: 1280px) {\n  .background-image-col{\n    margin-left: -20% !important;\n  }\n\n  card-on-hover{\n  margin-left: 25% !important;\n  margin-top: 15% !important;\n  }\n}\n\n@media only screen and (max-width: 1199px) {\n  .background-image-col{\n    background-image: url(\"../../../../../assets/images/banner/lady-two.png\");\n    background-repeat: no-repeat;\n    background-size: contain !important;\n    width:600px !important;\n    height:100% !important;\n    position:absolute !important;\n    margin-left:-6% !important;\n    margin-top:10%;\n  \n    position:absolute;\n  }\n .card-on-hover{\nmargin-top:-10% !important;\nmargin-left: 0% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  font-size:35px !important;\n  \n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n}\n\n}\n\n@media only screen and (max-width: 1099px) {\n  .background-image-col{\n    background-image: none !important;\n  }\n\n  card-on-hover{\n  margin-left: 5% !important;\n  margin-top: 15% !important;\n  }\n}\n\n\n@media only screen and (max-width: 991px) {\n  .background-image-col{\n    background-image: none !important;\n    width:100% !important;\n  }\n\n .card-on-hover{\nmargin-top:5% !important;\nmargin-left: -70% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  font-size:30px !important;\n  \n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n}\n\n.banner-buy-on-pamo{\n  padding:15px 10px !important;\n \n}\n\n.floating-btn{\n  margin-left:-2%  !important;\n  bottom:0;\n  margin-bottom:5%;\n}\n}\n\n\n\n@media only screen and (max-width: 950px) {\n  .card-on-hover{\n    margin-top:5% !important;\n    margin-left: -120% !important;\n    }\n    \n}\n\n@media only screen and (max-width: 899px) {\n  .card-on-hover{\n    margin-top:20% !important;\n    margin-left: -140% !important;\n    }\n    \n}\n\n@media only screen and (max-width: 865px) {\n  .card-on-hover{\n    margin-top:30% !important;\n    margin-left: -170% !important;\n    }\n    \n}\n\n@media only screen and (max-width: 850px) {\n  .card-on-hover{\n    margin-top:35% !important;\n    margin-left: -220% !important;\n    }\n    \n}\n\n@media only screen and (max-width: 830px) {\n  .card-on-hover{\n    margin-top:35% !important;\n    margin-left: -350% !important;\n    }\n    \n}\n\n@media only screen and (max-width: 810px) {\n  .card-on-hover{\n    margin-top:45% !important;\n    margin-left: -400% !important;\n    }\n    \n}\n\n@media only screen and (max-width: 799px) {\n  .card-on-hover{\n    margin-top:5% !important;\n    margin-left: -550% !important;\n    }\n}\n\n@media only screen and (max-width: 781px) {\n  .card-on-hover{\n    margin-top:5% !important;\n    margin-left: -750% !important;\n    }\n}\n\n@media only screen and (max-width: 770px) {\n  .card-on-hover{\n    margin-top:5% !important;\n    margin-left: -750% !important;\n    }\n}\n\n\n\n@media only screen and (max-width: 767px) {\n  .background-image-col{\n    background-image: none !important;\n  }\n\n .card-on-hover{\nmargin-top:-4% !important;\nmargin-left: 0% !important;\n}\n\n\n .download-btn{\nfont-size:12px !important;\n }\n\n .banner-col-1-text {\n  // font-size:5vw !important;\n  width:100% !important ;\n  // padding:0% -10% !important;\n  // margin: 0% -10% !important;\n}\n\n.get-app-btn{\n  margin:10px 0px !important;\n  padding:15px 25px !important;\n}\n\n.banner-buy-on-pamo{\n  padding:15px 10px !important;\n}\n\n.floating-btn{\n  margin-left:-2%  !important;\n  bottom:0;\n  margin-bottom:5%;\n}\n\n.banner-text-sub{\n  font-weight:lighter !important;\n  font-size: 15px !important;\n}\n\n.text-link{\n  font-size: 12px !important;\n  font-weight:lighter !important;\n}\n}\n\n@media only screen and (max-width: 620px) {\n  .promo-section{\n    padding:0% 0% !important;\n  }\n  \n  .shimmer-container{\n    padding:0% 0% !important;\n  }\n  \n  #banner-section{\n    width: 100% !important;\n    padding:0px 0% !important;\n    }\n\n    .banner-buy-on-pamo{\n      background: transparent linear-gradient(6deg, #7062f9 0%, #8d81fa 100%) 0% 0% no-repeat padding-box;\n     border-radius: 0px !important;\n    width:100% !important;\n    margin:0% !important;\n      height: 100%;\n\n    }\n\n    .banner-col-1-text {\n      .banner-text{\n        font-size:40px !important;\n      }\n    }  \n\n    \n}\n\n@media only screen and (max-width: 500px) {\n  .banner-col-1-text {\n    .banner-text{\n      font-size:30px !important;\n    }\n  }  \n}\n\n\n@media only screen and (max-width: 430px) {\n    .banner-col-1-text {\n      .banner-text{\n        font-size:30px !important;\n      }\n    }  \n}\n\n@media only screen and (max-width: 420px) {\n  .banner-col-1-text {\n    .banner-text{\n      font-size:28px !important;\n    }\n  }  \n}\n\n\n\n@media only screen and (max-width: 404px) {\n  .banner-col-1-text {\n    .banner-text{\n      font-size:28px !important;\n    }\n  }     \n}\n\n@media only screen and (max-width: 404px) {\n  .banner-col-1-text {\n    .banner-text{\n      font-size:28px !important;\n      line-height: 25px;\n    }\n  }     \n}\n\n@media only screen and (max-width: 385px) {\n  .banner-buy-on-pamo{\n    padding:0px 0px !important;\n  }     \n}\n\n@media only screen and (max-width: 350px) {\n  .banner-col-1-text {\n    .banner-text{\n      font-size:22px !important;\n      line-height: 15px !important;\n    }\n  }    \n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
